import React from "react";

import { DistributorsDataProvider } from "../../../common/data/lookup-data-providers/DistributorsDataProvider";
import { OrderAirlinesDataProvider } from "../../common/data-providers/OrderAirlinesDataProvider";
import { OrderRequestListingProvider } from "./context/OrderRequestListingProvider";
import { OrderRequestListing } from "./OrderRequestListing";

export const OrderRequestListingDashboard: React.VFC = () => {
    return (
        <OrderRequestListingProvider>
            <OrderAirlinesDataProvider>
                <DistributorsDataProvider>
                    <OrderRequestListing />
                </DistributorsDataProvider>
            </OrderAirlinesDataProvider>
        </OrderRequestListingProvider>
    );
};
